export const TIME_OF_DAY_CLASSES = [
  'time-of-day--night',
  'time-of-day--morning',
  'time-of-day--noon',
  'time-of-day--evening',
];

export function getTimeOfDayPeriod(date = new Date()) {
  const hour = date.getHours();

  if (hour >= 20 || hour < 8) return 'night';
  if (hour >= 8 && hour < 10) return 'morning';
  if (hour >= 12 && hour < 14) return 'noon';
  if (hour >= 17 && hour < 20) return 'evening';

  return null;
}

export function applyTimeOfDayClass(date = new Date()) {
  const period = getTimeOfDayPeriod(date);

  TIME_OF_DAY_CLASSES.forEach((className) => {
    document.body.classList.remove(className);
  });

  if (period) {
    document.body.dataset.timeOfDay = period;
  } else {
    delete document.body.dataset.timeOfDay;
  }
}

let intervalId = null;

export function initTimeOfDayUpdates() {
  applyTimeOfDayClass();

  if (intervalId !== null) {
    return;
  }

  intervalId = setInterval(applyTimeOfDayClass, 60_000);
}

// @deprecated kept for callers that expect a cleanup function
export function scheduleTimeOfDayUpdates() {
  initTimeOfDayUpdates();
  return () => {};
}
